import { withGetPartConfigOptions } from 'common/Hooks/withGetPartConfigOptions'
import { isStringInList } from 'common/Utils/StringUtilities'
import Alert from 'components/Common/Alert'
import Breadcrumbs from 'components/Common/Breadcrumb'
import Loader from 'components/Common/Loader'
import Select from 'components/Common/Select/Select'
import { USER_ROLE_SUPPLIER } from 'constants/userRoles'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { MetaTags } from 'react-meta-tags'
import { connect } from 'react-redux'
import { getFilteredProductionWithPartsInvoicing, getPartConfigOptions, getSuppliers } from 'store/actions'
import FilterProductionListWihPartsModal from './FilterProductionListWithPartsModal'
import { PaginationTable } from './PaginationTable'
import PartProduction from './PartProduction'
import { useTableState } from './useTableState'

export const SupplierInvoicing = ({ t, roles, getPartConfigOptions, totalImportProductionListWithPartsInvoicing, partConfigOptions, getFilteredProductionWithPartsInvoicing, partConfigOptionsLoading, productionListWithPartsInvoicing, suppliers, error, isLoadingProductionListWithPartsInvoicing, getSuppliers, totalRowsProductionListWithPartsInvoicing }) => {

	const [openedProductionIds, setOpenedProductionIds] = useState([])
	const [supplierSelected, setSupplierSelected] = useState(null)

	const { filters, keyword, page, pageSize, setFilters, setKeyword, setPage, setPageSize } = useTableState(getFilteredProductionWithPartsInvoicing)

	useEffect(() => {
		if (suppliers?.length == 0) {
			getSuppliers()
		}
	}, [])

	const isSupplier = () => {
		return isStringInList(USER_ROLE_SUPPLIER, roles) != null
	}

	const handleToggleProduction = (productionId) => {
		if (openedProductionIds.includes(productionId)) {
			setOpenedProductionIds(openedProductionIds.filter((id) => id !== productionId))
		} else {
			setOpenedProductionIds([...openedProductionIds, productionId])
		}

	}
	const getProductionsListWithPartsToRender = () => {

		if (!productionListWithPartsInvoicing) {
			return null
		}
		return productionListWithPartsInvoicing.map((production, index) => (
			<div key={`${production.id}_${index}`}>
				<PartProduction openedProductionIds={openedProductionIds} production={production} handleToggleProduction={handleToggleProduction} rowIndex={index} />
			</div>
		))
	}

	const parseSuppliers = suppliers => {
		return suppliers.map(supplier => {
			return {
				value: supplier?.id,
				label: supplier?.personalInformation?.firstName,
			}
		})
	}

	const handleOnChangeSupplierSelected = supplierId => {
		setSupplierSelected(supplierId)
		setFilters({ ...filters, supplierId })
	}

	const items = useMemo(() => {
		if (!productionListWithPartsInvoicing) {
			return null
		}
		return getProductionsListWithPartsToRender()
	}, [openedProductionIds, productionListWithPartsInvoicing])
	return (
		<div className='page-content marginFooter'>
			<MetaTags>
				<title>Proto&Go! | {t('supplier-invoicing', { ns: 'naming' })}</title>
			</MetaTags>
			<Breadcrumbs
				title={t('quality', { ns: 'naming' })}
				breadcrumbItems={[
					{
						item: t('supplier-invoicing', { ns: 'naming' }),
						link: '/supplier-invoicing',
					},
				]}
			/>
			{!isSupplier() && suppliers && suppliers.length > 0 && (
				<div className="d-flex mb-4 bg-white mx-2 py-3 w-100 ps-2">
					<span className="center-vertically me-3">Visualización cómo proveedor</span>
					<div>
						<Select
							placeholder="Selecciona un Proveedor"
							options={parseSuppliers(suppliers)}
							className="width-by-content "
							onChange={e => handleOnChangeSupplierSelected(e.target.value)}
							value={supplierSelected}
							disable={isLoadingProductionListWithPartsInvoicing}
						/>
					</div>
				</div>
			)}
			<div className='d-flex justify-content-center flex-column w-100 mb-1'>

				<div className='bg-white w-100 px-4 py-2 mx-2'>
					<FilterProductionListWihPartsModal totalImport={totalImportProductionListWithPartsInvoicing && !isLoadingProductionListWithPartsInvoicing && (!isSupplier() ? supplierSelected != null : true) ? totalImportProductionListWithPartsInvoicing : 0} keyword={keyword} setKeyword={setKeyword} setFilters={setFilters} filters={filters} getFilteredProductionWithPartsInvoicing={getFilteredProductionWithPartsInvoicing} />
				</div>
				{
					(isLoadingProductionListWithPartsInvoicing || partConfigOptionsLoading) ? <Loader className='mx-auto fs-1' /> : (error) ? <Alert type={'danger'} message={error} fitContent centered /> :
						<div className='d-flex w-100 flex-column'>
							{productionListWithPartsInvoicing && productionListWithPartsInvoicing.length > 0 && (!isSupplier() ? supplierSelected != null : true) ? (
								<>
									<div className='w-100 mx-2 sticky px-4 rounded d-flex flex-row align-items-center bg-white py-2 mb-2 fw-bold'>
										<span className='col-1'><i className='bx bx-code ms-1 fs-3 mt-1' ></i></span>
										<span className='col-1'>{t('Id', { ns: 'naming' })}</span>
										<span className='col-2'>{t('productionDate', { ns: 'naming' })}</span>
										<span className='col-2'>{t('status', { ns: 'naming' })}</span>
										<span className='col-2'>{t('shipmentProductionDate', { ns: 'naming' })}</span>
										<span className='col-1'>{t('weight', { ns: 'naming' })}</span>
										<span className='col-2'>{t('tracking', { ns: 'naming' })}</span>
										<span className='col-1'>{t('totalPrice', { ns: 'naming' })}</span>
									</div>
									{items}
								</>
							) : (
								<div>
									<div className="d-flex justify-content-center my-4">
										<h2>{t('noProductionsToShow', { ns: 'naming' })}</h2>
									</div>
								</div>
							)}
						</div>
				}
			</div>
			<PaginationTable
				page={page}
				pageSize={pageSize}
				setPage={setPage}
				totalItems={totalRowsProductionListWithPartsInvoicing && totalRowsProductionListWithPartsInvoicing > 0 && (!isSupplier() ? supplierSelected != null : true) ? totalRowsProductionListWithPartsInvoicing : 0}
				totalText={t('totalProductions', { ns: 'naming' })}
			/>

		</div>
	)
}

SupplierInvoicing.propTypes = {
	t: PropTypes.func,
	productionListWithPartsInvoicing: PropTypes.array,
	isLoadingProductionListWithPartsInvoicing: PropTypes.bool,
	error: PropTypes.string,
	suppliers: PropTypes.array,
	getSuppliers: PropTypes.func,
	roles: PropTypes.arrayOf(PropTypes.string),
	getPartConfigOptions: PropTypes.func,
	partConfigOptionsLoading: PropTypes.bool,
	getFilteredProductionWithPartsInvoicing: PropTypes.func,
	totalImportProductionListWithPartsInvoicing: PropTypes.number,
}

const mapStateToProps = (state) => ({
	productionListWithPartsInvoicing: state.Productions.productionListWithPartsInvoicing,
	isLoadingProductionListWithPartsInvoicing: state.Productions.isLoadingProductionListWithPartsInvoicing,
	error: state.Productions.error,
	suppliers: state.Users.suppliers,
	roles: state.Login.roles,
	partConfigOptions: state.Parts.partConfigOptions,
	partConfigOptionsLoading: state.Parts.partConfigOptionsLoading,
	totalRowsProductionListWithPartsInvoicing: state.Productions.totalRowsProductionListWithPartsInvoicing,
	totalImportProductionListWithPartsInvoicing: state.Productions.totalImportProductionListWithPartsInvoicing
})

const mapDispatchToProps = {
	getFilteredProductionWithPartsInvoicing,
	getSuppliers,
	getPartConfigOptions
}

export default connect(mapStateToProps, mapDispatchToProps)(withGetPartConfigOptions(withTranslation()(SupplierInvoicing)))
